export const getRelationText = (relationType: number) => {
    switch (relationType) {
        case 0:
            return '엄마';
        case 1:
            return '아빠';
        case 2:
            return '기타';
    }
};
